<script setup>
defineProps({
  table: {
    type: Object,
    required: true
  }
})
</script>

<template>
  <div class="table">
    <div class="inner">
      <div
        v-for="(content, index) in table"
        :key="index"
        class="card"
      >
        <p
          class="heading"
          :class="content.dowEn"
        >
          {{ content.dayJp }}
          <span>{{ content.day }}</span>
          <span>({{ content.dowJp }})</span>
        </p>
        <div class="content">
          <div class="weather">
            <figure>
              <img
                :src="`https://gvs.weathernews.jp/onebox/img/wxicon/${content.weather}.webp`"
                loading="lazy"
                alt=""
              >
            </figure>
            <p>{{ content.weatherJp }}</p>
          </div>
          <div class="info">
            <div class="temp">
              <p class="high">
                {{ content.high === null ? '-' : content.high }}<span class="unit">℃</span>
              </p>
              <p>/</p>
              <p class="low">
                {{ content.low === null ? '-' : content.low }}<span class="unit">℃</span>
              </p>
            </div>
            <p class="prec">
              {{ content.rain === null ? '-' : content.rain }}<span class="unit">%</span>
            </p>
            <div class="wind">
              <div class="wind__dir">
                <div
                  class="wind__dir-icon"
                >
                  <svg
                    v-if="content.windSpd!==0 && content.windSpd!==null"
                    xmlns="http://www.w3.org/2000/svg"
                    width="11"
                    height="15"
                    viewBox="0 0 11 15"
                    :data-rank="content.windRank"
                    :style="`transform: rotate(calc(1deg * ${content.windDir*22.5})) scale(1.4)`"
                  >
                    <path
                      d="M9.91706 1.33286L5.48529 13.7418L1.05353 1.33286L5.31805 5.17093L5.48529 5.32145L5.65253 5.17093L9.91706 1.33286Z"
                      stroke="#333333"
                      stroke-width="0.5"
                    />
                  </svg>
                </div>
                <p class="wind__dir-text">
                  {{ content.windDirJp === null ? '-' : content.windDirJp }}
                </p>
              </div>
              <div class="wind__value">
                <p class="wind__value-text">
                  {{ content.windSpd === null ? '-' : content.windSpd }}<span class="unit">m/s</span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="data">
          <div class="icon">
            <figure class="golf">
              <img
                :src="`https://gvs.weathernews.jp/golf/image/golf_status/icon_status_${content.status}.svg`"
                alt=""
                loading="lazy"
              >
            </figure>
            <p>{{ content.statusJp }}</p>
          </div>
          <div class="icon">
            <figure class="clothes">
              <img
                v-if="content.clothes !== null"
                :src="`https://gvs.weathernews.jp/golf/image/clothes/c-rank-${content.clothes}.svg`"
                alt=""
                loading="lazy"
              >
            </figure>
            <p>{{ content.clothesJp ? content.clothesJp : "" }}</p>
          </div>
          <div class="sun">
            <p class="sunrise">
              {{ content.sunrise }}
            </p>
            <p class="sunset">
              {{ content.sunset }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.table {
  width: 100%;
  height: 236px;
  overflow-x: scroll;
  padding-bottom: 2px;
  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }
  &::-webkit-scrollbar-track {
    border-radius: 8px;
    background-color: #eef1f8;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 8px;
    background: #438fec;
  }
  .inner {
    display: flex;
    justify-content: center;
    width: 841px;
    border-radius: 8px;
    overflow: hidden;
    border: solid 1px #e3e6e9;
  }
  .card {
    display: flex;
    flex-direction: column;
    flex: 1;
    align-items: center;
    justify-content: space-between;
    height: 224px;
    &:not(:last-child) {
      border-right: solid 1px #e3e6e9;
    }
    &:first-child {
      .heading {
        background-color: #FBFBED;
      }
    }
    .heading {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: .5em;
      width: 100%;
      font-size: 16px;
      line-height: 26px;
      background-color: #F5F5F5;
      &.sat {
        color: #0060FF;
      }
      &.hol {
        color: #FF3000;
      }
    }
    .content {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 15px;
      width: 100%;
      padding-block: 10px;
      border-bottom: solid 2px #C6CCDA;
      .weather {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 3px;
        figure {
          aspect-ratio: 152 / 112;
          width: 100px;
        }
        img {
          width: 100%;
        }
        p {
          color: #000;
          text-align: center;
          font-size: 15px;
          line-height: 1em;
          letter-spacing: .25px;
        }
      }
      .info {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 5px;
        .temp {
          display: flex;
          align-items: center;
          gap: 4px;
          p {
            color: #c6ccda;
            font-size: 22px;
            font-weight: 500;
            line-height: 1em;
            letter-spacing: .25px;
          }
          .high {
            color: #F64D00;
            font-size: 22px;
          }
          .low {
            color: #0075F3;
            font-size: 22px;
          }
        }
        .prec {
          padding-left: 20px;
          background-image: url('https://gvs.weathernews.jp/golf/image/common/icon_prec.svg');
          background-position: left center;
          background-repeat: no-repeat;
          background-size: 12px;
          color: #000;
          font-size: 22px;
          font-weight: 500;
          line-height: 1em;
          letter-spacing: .25px;
        }
        .wind {
          display: flex;
          align-items: flex-end;
          gap: 5px;
          &__dir {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 5px;
            &-icon {
              height: 15px;
            }
            &-text {
              color: #000;
              text-align: center;
              font-size: 13px;
              line-height: 1em;
              letter-spacing: .25px;
            }
          }
          &__value {
            display: flex;
            align-items: center;
            color: #000;
            font-size: 22px;
            font-weight: 500;
            line-height: 1em;
            letter-spacing: .25px;
          }
          svg {
            &[data-rank='0'] {
            fill: #ffffff;
            }
            &[data-rank='1'] {
              fill: #03aeef;
            }
            &[data-rank='2'] {
              fill: #05ad50;
            }
            &[data-rank='3'] {
              fill: #febf00;
            }
            &[data-rank='4'] {
              fill: #e86200;
            }
            &[data-rank='5'] {
              fill: #fe0000;
            }
          }
        }
        .unit {
          margin-left: 3px;
          font-size: 15px;
        }
      }
    }
    .data {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 10px;
      width: 100%;
      padding-block: 10px;
      .icon {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 3px;
        .clothes {
          width: 50px;
          aspect-ratio: 50 / 43;
          padding-top: 7px;
        }
        .golf {
          width: 50px;
          aspect-ratio: 1 / 1;
        }
        img {
          width: 100%;
        }
        p {
          color: #000;
          text-align: center;
          font-size: 12px;
          line-height: 1em;
          letter-spacing: .25px;
        }
      }
      .sun {
        display: flex;
        flex-direction: column;
        gap: 10px;
        p {
          padding-left: 30px;
          background-position: left center;
          background-repeat: no-repeat;
          background-size: 25px;
          color: #000;
          font-size: 18px;
          line-height: 1em;
        }
        .sunrise {
          background-image: url('https://gvs.weathernews.jp/golf/image/common/icon_sunrise.svg');
        }
        .sunset {
          background-image: url('https://gvs.weathernews.jp/golf/image/common/icon_sunset.svg');
        }
      }
    }
  }
}
</style>
